import {
  CheckMetadata,
  createSimpleCheckMetadataArray,
} from 'dashboard/components/ChecksTable/computeCheckMetadata';
import RiskLevelSticker from 'dashboard/components/RiskLevelSticker';
import { SelfieAccountComparison } from 'dashboard/models/check';

export const computeSelfieAccountComparisonMetadata = (
  check: SelfieAccountComparison,
): CheckMetadata => {
  const metadata = [];
  if (check.metadata && check.reasons) {
    const {
      'passed-count': passedCount,
      'total-count': totalCount,
      risks: risks,
    } = check.metadata || {};

    const faceMismatchRiskData = risks?.find((r) => r.reason === 'face_mismatch');

    if (faceMismatchRiskData && faceMismatchRiskData['level']) {
      metadata.push({
        label: 'Face Comparison Risk',
        value: RiskLevelSticker({ riskLevel: faceMismatchRiskData['level'] }),
      });
    }

    if (passedCount != null && totalCount != null && totalCount > 0) {
      metadata.push({
        label: 'Matched Selfies',
        value: `${passedCount}`,
      });
      metadata.push({
        label: 'Total Account Selfies',
        value: `${totalCount}`,
      });
    }
  }

  return {
    metadata: createSimpleCheckMetadataArray(metadata),
    hideIfVerificationPassed: false,
  };
};
